<section class="bg-gray-50 px-3 md:px-5 2xl:px-28 3xl:px-52 py-20">
  <section class="container mx-auto">
    <div class="flex flex-col gap-5 items-center">
      <div
        class="rounded-2xl background w-full h-[40vh] py-3 lg:pe-10 flex items-end justify-center lg:items-center lg:justify-end"
      >
        <h3
          class="text-center lg:text-end text-white text-3xl lg:text-5xl font-bold"
        >
          Discover the Only<br />
          Used Tesla Difference
        </h3>
      </div>

      <div class="divide-y border-y">

        <div class="flex flex-col lg:flex-row items-center gap-2.5 py-4">
          <!-- Image -->
          <div class="w-full lg:basis-1/4 2xl:basis-[20%]">
            <img
              src="/assets/images/OUT-tesla-8.jpg"
              class="rounded-xl lg:max-h-[140px] object-cover"
              alt="A tesla Model 3"
            />
          </div>
          <div class="flex gap-4 lg:gap-2 lg:basis-3/4 2xl:basis-[70%]">
            <!-- Number -->
            <span
              class="text-gray-400 lg:basis-1/4 lg:text-center  2xl:mr-5 text-3xl font-bold"
              >01</span
            >
            <!-- Text -->
            <div class="lg:basis-3/4 2xl:basis-[70%]">
              <h4 class="font-semibold text-xl lg:text-3xl">
                Only Used Tesla Listings
              </h4>
              <p class="text-sm md:text-base">
                Find the perfect used Tesla for sale or set your own used Tesla
                for sale - ad live for just $47. Your ad remains active until
                your car is sold.
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-col lg:flex-row items-center gap-2.5 py-4">
          <!-- Image -->
          <div class="w-full lg:basis-1/4 2xl:basis-[20%]">
            <img
              src="/assets/images/OUT-tesla-13.jpg"
              class="rounded-xl lg:max-h-[140px] object-cover"
              alt="A tesla Model 3"
            />
          </div>
          <div class="flex gap-4 lg:gap-2 lg:basis-3/4 2xl:basis-[70%]">
            <!-- Number -->
            <span
              class="text-gray-400 lg:basis-1/4 lg:text-center 2xl:mr-5 text-3xl font-bold"
              >02</span
            >
            <!-- Text -->
            <div class="lg:basis-3/4">
              <h4 class="font-semibold text-xl lg:text-3xl">Sell Your Tesla</h4>
              <p class="text-sm md:text-base">
                We've got you, we offer a comprehensive pricing strategy,
                ensuring the best value for your used Tesla for sale.
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-col lg:flex-row items-center gap-2.5 py-4">
          <!-- Image -->
          <div class="lg:basis-1/4 2xl:basis-[20%]">
            <img
              src="/assets/images/OUT-tesla-12.jpg"
              class="rounded-xl lg:max-h-[140px] object-cover"
              alt="A tesla Model 3"
            />
          </div>
          <div class="flex gap-4 lg:gap-2 lg:basis-3/4 2xl:basis-[70%]">
            <!-- Number -->
            <span class="text-gray-400 lg:basis-1/4 lg:text-center 2xl:mr-5 text-3xl font-bold"
              >03</span
            >
            <!-- Text -->
            <div class="lg:basis-3/4">
              <h4 class="font-semibold text-xl lg:text-3xl">
                Boost Your Reach
              </h4>
              <p class="text-sm md:text-base">
                For an additional $100, enjoy a 10-day Facebook Boost. With the
                power of Facebook's AI, we spotlight your car across four
                neighboring states.
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-col lg:flex-row items-center gap-2.5 py-4">
          <!-- Image -->
          <div class="lg:basis-1/4 2xl:basis-[20%]">
            <img
              src="/assets/images/OUT-tesla-11.jpg"
              class="rounded-xl lg:max-h-[140px] object-cover"
              alt="A tesla Model 3"
            />
          </div>
          <div class="flex gap-4 lg:gap-2 lg:basis-3/4 2xl:basis-[70%]">
            <!-- Number -->
            <span class="text-gray-400 lg:basis-1/4 lg:text-center 2xl:mr-5 text-3xl font-bold"
              >04</span
            >
            <!-- Text -->
            <div class="lg:basis-3/4">
              <h4 class="font-semibold text-xl lg:text-3xl">
                Increase Your Visibility
              </h4>
              <p class="text-sm md:text-base">
                Your listing extends to our verified platforms including
                <a href="https://www.reddit.com/r/onlyusedtesla">Reddit</a> ,
                <a href="https://twitter.com/onlyusedtesla">Twitter</a>, and our
                <a href="https://www.facebook.com/onlyusedtesla">Facebook</a>
                Page.
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-col lg:flex-row items-center gap-2.5 py-4">
          <!-- Image -->
          <div class="lg:basis-1/4 2xl:basis-[20%]">
            <img
              src="/assets/images/OUT-tesla-10.jpg"
              class="rounded-xl lg:max-h-[140px] object-cover"
              alt="A tesla Model 3"
            />
          </div>
          <div class="flex gap-4 lg:gap-2 lg:basis-3/4 2xl:basis-[70%]">
            <!-- Number -->
            <span class="text-gray-400 lg:basis-1/4 lg:text-center 2xl:mr-5 text-3xl font-bold"
              >05</span
            >
            <!-- Text -->
            <div class="lg:basis-3/4">
              <h4 class="font-semibold text-xl lg:text-3xl">
                Transparent Dealings
              </h4>
              <p class="text-sm md:text-base">
                Every used Tesla for sale listing includes a Carfax report.
                Knowledge is power!
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-col lg:flex-row items-center gap-2.5 py-4">
          <!-- Image -->
          <div class="lg:basis-1/4 2xl:basis-[20%]">
            <img
              src="/assets/images/OUT-tesla-9.jpg"
              class="rounded-xl lg:max-h-[140px] object-cover"
              alt="A tesla Model 3"
            />
          </div>
          <div class="flex gap-4 lg:gap-2 lg:basis-3/4 2xl:basis-[70%]">
            <!-- Number -->
            <span
              class="text-gray-400 lg:basis-1/4 lg:text-center 2xl:mr-5 text-3xl font-bold"
              >06</span
            >
            <!-- Text -->
            <div class="lg:basis-3/4">
              <h4 class="font-semibold text-xl lg:text-3xl">
                Quick Cash Offers
              </h4>
              <p class="text-sm md:text-base">
                Interested in a swift sale? Receive cash offers from our network
                of trusted dealers. Just ask!
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-col lg:flex-row lg:items-center gap-2.5 py-4">
          <!-- Image -->
          <div class="lg:basis-1/4 2xl:basis-[20%]">
            <img
              src="/assets/images/OUT-tesla-14.jpg"
              class="rounded-xl lg:max-h-[140px] object-cover"
              alt="A tesla Model 3"
            />
          </div>
          <div class="flex gap-4 lg:gap-2 lg:basis-3/4 2xl:basis-[70%]">
            <!-- Number -->
            <span
              class="text-gray-400 lg:basis-1/4 lg:text-center 2xl:mr-5 text-3xl font-bold"
              >07</span
            >
            <!-- Text -->
            <div class="lg:basis-3/4">
              <h4 class="font-semibold text-xl lg:text-3xl">Go HD</h4>
              <p class="text-sm md:text-base">
                Elevate your listing with our HD video option.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
